import { render, staticRenderFns } from "./MonthlyProfitList.vue?vue&type=template&id=710ffc75"
import script from "./MonthlyProfitList.vue?vue&type=script&lang=js"
export * from "./MonthlyProfitList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports